import { Button, InputGroup, Intent, Tooltip } from "@blueprintjs/core"
import { useState } from "react"

import { FlexContainer, FlexContainerAndItem, FlexItem } from "../../../../styled/flexbox.styled"
import AddNewDatasetDialog from "../components/AddNewDatasetDialog"
import GeoFilter from "./GeoFilter"
import SourceFilter from "./SourceFilter"

import CurrencyFilter from "./CurrencyFilter"
import DatasetUploadButton from "./DatasetUploadButton"
import SectorFilter from "./SectorFilter"
import { SideContentContainer } from "./Sidebar.styled"
import { DatasetFilters } from "./types"

interface ISidebarProps {
  searchText: string
  setSearchText: (searchText: string) => void
  filters: DatasetFilters
  handleFilterChange: (filters: DatasetFilters) => void
}

const Sidebar = ({ searchText, setSearchText, filters, handleFilterChange }: ISidebarProps) => {
  const [isOpenDialog, setIsOpenDialog] = useState(false)

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setSearchText(value)
    handleFilterChange({ nameParam: value, codeStartswithParam: value, longNameParam: value })
  }

  return (
    <SideContentContainer flexDirection="column" gap="20px">
      <AddNewDatasetDialog
        isOpenDialog={isOpenDialog}
        setIsOpenDialog={setIsOpenDialog}
        title="Add Dataset"
      />
      <FlexContainerAndItem flexDirection="row" gap="10px" alignItems="center">
        <FlexItem flexGrow={1}>
          <InputGroup
            placeholder="Search datasets..."
            leftIcon="search"
            value={searchText}
            onChange={handleSearchChange}
          />
        </FlexItem>
        <Tooltip content="Add new ticker(s) or create custom dataset">
          <Button
            icon="plus"
            intent={Intent.PRIMARY}
            minimal
            outlined
            onClick={() => setIsOpenDialog(true)}
          />
        </Tooltip>
      </FlexContainerAndItem>
      
      <DatasetUploadButton />
      
      <FlexContainer flexDirection="column" gap="10px">
        <SourceFilter filters={filters} onFilterChange={handleFilterChange} />
        <GeoFilter filters={filters} onFilterChange={handleFilterChange} />
        <CurrencyFilter filters={filters} onFilterChange={handleFilterChange} />
        <SectorFilter filters={filters} onFilterChange={handleFilterChange} />
      </FlexContainer>
    </SideContentContainer>
  )
}

export default Sidebar
